import {Badge, Button, Icon, Typography} from '@sollapay/ui/components';

import {RosterStatusBadge} from './RosterStatusBadge';

import type {RosterStatus} from './RosterStatusBadge';
import type {FC} from 'react';

export interface RosterPaneHeaderProps {
  title: string;
  typeLabel?: string;
  status?: RosterStatus;
  positionLabel: string;
  removeLabel: string;
  onRemove?: () => void;
}

/** Heading of one roster row's detail pane: name, type chip, error badge, "n of m" and remove (omit `onRemove`, e.g. when read-only, to hide it). */
export const RosterPaneHeader: FC<RosterPaneHeaderProps> = ({
  title,
  typeLabel,
  status,
  positionLabel,
  removeLabel,
  onRemove
}) => (
  <div data-slot="roster-pane-header" className="flex items-start justify-between gap-4">
    <div className="flex min-w-0 flex-col gap-1">
      <div className="flex flex-wrap items-center gap-3">
        <Typography as="h2" size="md" weight="semibold">
          {title}
        </Typography>
        {typeLabel && (
          <Badge variant="neutral" size="md">
            {typeLabel}
          </Badge>
        )}
        {status && <RosterStatusBadge {...status} />}
      </div>
      <Typography size="xs" color="tertiary">
        {positionLabel}
      </Typography>
    </div>
    {onRemove && (
      <Button
        variant="tertiary"
        size="sm"
        icon={<Icon name="delete" className="size-4" />}
        onClick={onRemove}
        data-slot="remove-roster-row"
      >
        {removeLabel}
      </Button>
    )}
  </div>
);
